import * as React from 'react';
import { connect } from 'react-redux';
import { FormGroup } from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';
import * as Features from '../../../../shared/Features';
import { Translate } from '../../../../shared/LanguageService';
import { handleError } from '../../../../shared/ErrorCatching';
import { assign } from '../../../../shared/Assign';
import FormSelect from '../../../../components/common/FormSelect';
import * as actions from './SinglePhotographerInvoiceActions';
import { IPhotographerInvoice } from './SinglePhotographerInvoiceTypes';
import ViewPhotographerInvoiceModal from './ViewPhotographerInvoiceModal';
import InvoiceListRow from './InvoiceListRow';
import moment from 'moment';

class SinglePhotographerInvoicePage extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.showPendingInvoice = this.showPendingInvoice.bind(this);
        this.onInvoiceNumberChange = this.onInvoiceNumberChange.bind(this);
        this.onRejectMessageChange = this.onRejectMessageChange.bind(this);
        this.savePendingInvoice = this.savePendingInvoice.bind(this);
        this.showPreviewInvoice = this.showPreviewInvoice.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.photographerChanged = this.photographerChanged.bind(this);
        this.rejectPendingInvoice = this.rejectPendingInvoice.bind(this);

        this.state = {
            showModal: false,
            showSaveModal: false,
            photographerId: 0,
            invoice: {},
            checksum: 0,
            working: false,
            invoiceNumber: '',
            rejectMessage: '',
            errors: {}
        };
    }

    componentDidMount(): void {
        if (Features.hasFeature(Features.ViewAllPhotographerInvoices, this.props.user)) {
            this.props.actions
                .getFilter(this.props.employedPhotographers)
                .catch((error: any) => handleError(error));
        } else if (Features.hasFeature(Features.ViewOwnPhotographerInvoices, this.props.user)) {
            this.setState({ photographerId: 0 });
            this.props.actions.getLists(0);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({ rejectMessage: nextProps.rejectMessage });
    }

    componentWillUnmount(): void {
        this.props.actions.clearState();
    }

    closeModal() {
        this.setState({
            showModal: false,
            showSaveModal: false,
            invoice: {},
            working: false,
            invoiceNumber: '',
            rejectMessage: ''
        });
    }

    photographerChanged(e) {
        this.setState({ photographerId: e.target.value });
        this.props.actions.clearFilterPlaceholder();

        this.props.actions.getLists(e.target.value).catch((error: any) => {
            handleError(error);
            this.props.actions.clearListsFromState();
        });
    }

    showPendingInvoice(invoice: IPhotographerInvoice, invoiceNumber: string): void {
        let date = moment(invoice.name);
        this.props.actions
            .getPendingInvoice(
                this.state.photographerId,
                invoiceNumber,
                date.year(),
                date.month() + 1
            )
            .then(() => {
                this.setState({
                    showSaveModal: true,
                    invoice: invoice
                });
            })
            .catch((error: any) => handleError(error));
    }

    onInvoiceNumberChange(e: any): void {
        let newState = assign({}, this.state);
        newState.invoiceNumber = e.target.value;
        this.setState(newState);
    }

    onRejectMessageChange(e: any): void {
        let newState = assign({}, this.state);
        newState.rejectMessage = e.target.value;
        this.setState(newState);
    }

    savePendingInvoice(): void {
        this.setState({ working: true });

        let rejectMessage = this.state.rejectMessage ? this.state.rejectMessage : null;
        this.props.actions
            .savePendingInvoice(this.state.invoiceNumber, this.props.checksum)
            .then(() => {
                this.setState({
                    showSaveModal: false,
                    working: false,
                    invoiceNumber: '',
                    rejectMessage: ''
                });
            })
            .catch((error: any) => {
                handleError(error, (errors: any) => {
                    this.setState({ errors: errors });
                });
                this.setState({ working: false });
            });
    }

    showPreviewInvoice(invoice: IPhotographerInvoice): void {
        this.props.actions
            .getPreviewInvoice(this.state.photographerId)
            .then(() => {
                this.setState({
                    showModal: true,
                    invoice: invoice
                });
            })
            .catch((error: any) => handleError(error));
    }

    showHistoricInvoice(invoice: IPhotographerInvoice): void {
        if (this.props.employedPhotographers) {
            let date = moment(invoice.name);
            this.props.actions
                .getHistoricEmployedInvoice(
                    this.state.photographerId,
                    date.year(),
                    date.month() + 1
                )
                .then(() => {
                    this.setState({
                        showModal: true,
                        invoice: invoice
                    });
                })
                .catch((error: any) => handleError(error));
        } else {
            this.props.actions
                .getHistoricInvoice(this.state.photographerId, invoice.id)
                .then(() => {
                    this.setState({
                        showModal: true,
                        invoice: invoice
                    });
                })
                .catch((error: any) => handleError(error));
        }
    }

    rejectPendingInvoice(invoice: IPhotographerInvoice): void {
        this.setState({
            working: true
        });

        this.props.actions
            .rejectPendingInvoice(
                this.state.photographerId,
                invoice.year,
                invoice.month,
                invoice.day,
                this.state.rejectMessage
            )
            .then(() => {
                this.setState({
                    showSaveModal: false,
                    working: false,
                    invoiceNumber: '',
                    rejectMessage: ''
                });
            })
            .catch((error: any) => {
                handleError(error, (errors: any) => {
                    this.setState({ errors: errors });
                });
                this.setState({ working: false });
            });
    }

    render() {
        return (
            <div>
                <h1>{Translate('photographer-invoice/title')}</h1>
                <fieldset>
                    <form>
                        {Features.hasFeature(
                            Features.ViewAllPhotographerInvoices,
                            this.props.user
                        ) && (
                            <Row>
                                <Col sm={12} md={6}>
                                    <FormGroup>
                                        <FormSelect
                                            name="photographer"
                                            onChange={this.photographerChanged}
                                        >
                                            {this.props.filter.availablePhotographers.map(
                                                (s: any) => {
                                                    return (
                                                        <option key={s.id} value={s.id}>
                                                            {s.name}
                                                        </option>
                                                    );
                                                }
                                            )}
                                        </FormSelect>
                                    </FormGroup>
                                </Col>
                            </Row>
                        )}
                    </form>
                    <h2>{Translate('photographer-invoices/lists/pending/header')}</h2>
                    {this.props.pendingInvoices.map((x: IPhotographerInvoice, index: number) => (
                        <InvoiceListRow
                            key={index}
                            invoice={x}
                            view={(invoice: IPhotographerInvoice) =>
                                this.showPendingInvoice(invoice, null)
                            }
                            rejected={x.hasBeenRejected}
                        />
                    ))}
                    <h2>{Translate('photographer-invoices/lists/previews/header')}</h2>
                    {this.props.previewInvoices.map((x: IPhotographerInvoice, index: number) => (
                        <InvoiceListRow
                            key={index}
                            invoice={x}
                            view={(invoice: IPhotographerInvoice) =>
                                this.showPreviewInvoice(invoice)
                            }
                            rejected={false}
                        />
                    ))}
                    <h2>{Translate('photographer-invoices/lists/history/header')}</h2>
                    {this.props.invoiceHistory.map((x: IPhotographerInvoice, index: number) => (
                        <InvoiceListRow
                            key={index}
                            invoice={x}
                            view={(invoice: IPhotographerInvoice) =>
                                this.showHistoricInvoice(invoice)
                            }
                            rejected={false}
                        />
                    ))}
                    {this.state.showModal && (
                        <ViewPhotographerInvoiceModal
                            html={this.props.html}
                            closeModal={() => this.closeModal()}
                            allowSaving={false}
                            allowRejecting={undefined}
                            errors={undefined}
                            rejectMessage={undefined}
                            onRejectMessageChange={undefined}
                            invoice={undefined}
                            reject={undefined}
                            showRejectMessage={undefined}
                            invoiceNumber={undefined}
                            onInvoiceNumberChange={undefined}
                            instructions={undefined}
                            working={undefined}
                            update={undefined}
                            save={undefined}
                        />
                    )}
                    {this.state.showSaveModal &&
                        !Features.hasFeature(Features.CreatePhotographerInvoice, this.props.user) &&
                        !Features.hasFeature(
                            Features.RejectPhotographerInvoice,
                            this.props.user
                        ) && (
                            <ViewPhotographerInvoiceModal
                                html={this.props.html}
                                closeModal={() => this.closeModal()}
                                allowSaving={false}
                                allowRejecting={undefined}
                                errors={undefined}
                                rejectMessage={undefined}
                                onRejectMessageChange={undefined}
                                invoice={undefined}
                                reject={undefined}
                                showRejectMessage={undefined}
                                invoiceNumber={undefined}
                                onInvoiceNumberChange={undefined}
                                instructions={undefined}
                                working={undefined}
                                update={undefined}
                                save={undefined}
                            />
                        )}
                    {this.state.showSaveModal &&
                        !(
                            Features.hasFeature(
                                Features.CreatePhotographerInvoice,
                                this.props.user
                            ) &&
                            this.state.photographerId === 0 &&
                            !this.props.user.details.isImpersonated
                        ) &&
                        !this.props.employedPhotographers &&
                        Features.hasFeature(
                            Features.RejectPhotographerInvoice,
                            this.props.user
                        ) && (
                            <ViewPhotographerInvoiceModal
                                html={this.props.html}
                                closeModal={() => this.closeModal()}
                                allowSaving={false}
                                allowRejecting={!this.state.invoice.hasBeenRejected}
                                invoice={this.state.invoice}
                                rejectMessage={this.state.rejectMessage}
                                errors={this.state.errors}
                                onRejectMessageChange={(e: any) => this.onRejectMessageChange(e)}
                                reject={(invoice: IPhotographerInvoice) =>
                                    this.rejectPendingInvoice(invoice)
                                }
                                showRejectMessage={this.state.invoice.hasBeenRejected}
                                invoiceNumber={undefined}
                                onInvoiceNumberChange={undefined}
                                instructions={undefined}
                                working={undefined}
                                update={undefined}
                                save={undefined}
                            />
                        )}

                    {this.state.showSaveModal && this.props.employedPhotographers && (
                        <ViewPhotographerInvoiceModal
                            html={this.props.html}
                            closeModal={() => this.closeModal()}
                            allowSaving={false}
                            allowRejecting={false}
                            invoice={this.state.invoice}
                            rejectMessage={undefined}
                            errors={this.state.errors}
                            onRejectMessageChange={undefined}
                            reject={undefined}
                            showRejectMessage={undefined}
                            invoiceNumber={undefined}
                            onInvoiceNumberChange={undefined}
                            instructions={undefined}
                            working={undefined}
                            update={undefined}
                            save={undefined}
                        />
                    )}

                    {this.state.showSaveModal &&
                        Features.hasFeature(Features.CreatePhotographerInvoice, this.props.user) &&
                        this.state.photographerId === 0 &&
                        !this.props.user.details.isImpersonated &&
                        !this.props.employedPhotographers &&
                        Features.hasFeature(
                            Features.RejectPhotographerInvoice,
                            this.props.user
                        ) && (
                            <ViewPhotographerInvoiceModal
                                html={this.props.html}
                                closeModal={() => this.closeModal()}
                                allowSaving={!this.state.invoice.hasBeenRejected}
                                allowRejecting={!this.state.invoice.hasBeenRejected}
                                showRejectMessage={this.state.invoice.hasBeenRejected}
                                working={this.state.working}
                                invoice={this.state.invoice}
                                invoiceNumber={this.state.invoiceNumber}
                                onInvoiceNumberChange={(e: any) => this.onInvoiceNumberChange(e)}
                                rejectMessage={this.state.rejectMessage}
                                onRejectMessageChange={(e: any) => this.onRejectMessageChange(e)}
                                save={() => this.savePendingInvoice()}
                                update={(invoice: IPhotographerInvoice) =>
                                    this.showPendingInvoice(invoice, this.state.invoiceNumber)
                                }
                                errors={this.state.errors}
                                instructions={this.props.instructions}
                                reject={(invoice: IPhotographerInvoice) =>
                                    this.rejectPendingInvoice(invoice)
                                }
                            />
                        )}
                </fieldset>
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        pendingInvoices: state.singlePhotographerInvoice.pendingInvoices,
        previewInvoices: state.singlePhotographerInvoice.previewInvoices,
        invoiceHistory: state.singlePhotographerInvoice.invoiceHistory,
        filter: state.singlePhotographerInvoice.filter,
        html: state.singlePhotographerInvoice.html,
        checksum: state.singlePhotographerInvoice.checksum,
        user: state.user,
        instructions: state.singlePhotographerInvoice.instructions,
        rejectMessage: state.singlePhotographerInvoice.rejectMessage
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getFilter: (employedPhotographers: boolean) =>
                dispatch(actions.getPhotographerInvoiceFilter(employedPhotographers)),
            clearFilterPlaceholder: () => dispatch(actions.clearFilterPlaceholder()),
            getLists: (photographerId: number) => dispatch(actions.getLists(photographerId)),
            getPendingInvoice: (
                photographerId: number,
                invoiceNumber: string,
                year: number,
                month: number
            ) => dispatch(actions.getPendingInvoice(photographerId, invoiceNumber, year, month)),
            savePendingInvoice: (invoiceNumber: string, checksum: number) =>
                dispatch(actions.savePendingInvoice(invoiceNumber, checksum)),
            getPreviewInvoice: (photographerId: number) =>
                dispatch(actions.getPreviewInvoice(photographerId)),
            getHistoricInvoice: (photographerId: number, invoiceId: number) =>
                dispatch(actions.getHistoricInvoice(photographerId, invoiceId)),
            getHistoricEmployedInvoice: (photographerId: number, year: number, month: number) =>
                dispatch(actions.getHistoricEmployedInvoice(photographerId, year, month)),
            clearState: () => dispatch(actions.clearState()),
            rejectPendingInvoice: (
                photographerId: number,
                year: number,
                month: number,
                day: number,
                rejectMessage: string
            ) =>
                dispatch(
                    actions.rejectPendingInvoice(photographerId, year, month, day, rejectMessage)
                ),
            clearListsFromState: () => dispatch(actions.clearListsFromState())
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SinglePhotographerInvoicePage);
